import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocumentsListItemContent = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-content", { ref: ref }, children));
};
export default VeltNotificationsPanelContentDocumentsListItemContent;
